import axios from 'axios';
import { REF_ENUM } from "../component/utils/TranscoUtils";
import moment from 'moment';
const USER_API_BASE_URL = process.env.REACT_APP_API_URL + '/api/utils';

class UtilsService {
    getHeader(lang) {
        return {
            "accept-language": lang
        };
    }

    fetchUtilsByRefName(refName) {
        return axios({
            url: USER_API_BASE_URL + '/referentiel/' + refName + '?t=' + Date.now(),
            method: 'get'
        })
    }

    fetchGetDistance(start, end) {
        let query = {
            start: {
                x: start.latitude,
                y: start.longitude
            },
            end: {
                x: end.latitude,
                y: end.longitude
            }
        };
        return axios.post(USER_API_BASE_URL + '/distance', query);
    }


    fetchUtilsByLocalRefName(refName) {
        return axios({
            url: USER_API_BASE_URL + '/referentiel/local/' + refName,
            method: 'get'
        })
    }

    fetchLocalReferentiel(customerCodes) {
        let query = {
            customerCodes : customerCodes
        }
        return axios.post(USER_API_BASE_URL + '/referentiellocal', query);
    }

    arrayToObject = (array) =>
        array.reduce((obj, item) => {
            obj[item.id] = item.name
            return obj
        }, {})

    refreshRef = async (lang, force) => {
        const dateRef = localStorage.getItem("date_ref");
        const refValide = moment(dateRef).isAfter(moment().subtract(1, 'days'));
        Object.keys(REF_ENUM).forEach(key => {
            if(force) {
                localStorage.setItem(REF_ENUM[key].value, null);
            }
            const refExist = localStorage.getItem(REF_ENUM[key].value);
            if(!refExist || refExist === 'null' || !refValide || force) {
                this.fetchUtilsByRefName(REF_ENUM[key].ref, lang).then(res => {
                    if(res) {
                        const keyData = Object.keys(res.data._embedded)[0];
                        localStorage.setItem(REF_ENUM[key].value, JSON.stringify(this.arrayToObject(res.data._embedded[keyData])));
                    }
                }).catch(error => {
                })
            }
        });
        localStorage.setItem("date_ref", moment().format())
    }
}
export default new UtilsService();